import React, { useEffect, useState } from "react";
import API from "../../api/axiosConfig";
import { motion } from "framer-motion";
import { toast } from "react-toastify";
import { Pencil, Trash, Plus, ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import SeccionsModal from "../../components/modals/SeccionsModal";

export default function CompanySeccions() {
  const [seccions, setSeccions] = useState([]);
  const [modalInfo, setModalInfo] = useState({ open: false, seccion: null });

  const user = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();

  const fetchSeccions = async () => {
    try {
      const companyId = user.company.id ?? user.company._id;
      const res = await API.get(`/secciones/company/${companyId}`);
      // ✅ Después — el backend devuelve 'secciones' (con e), no 'seccions'
      const raw = res.data?.data?.secciones ?? res.data?.secciones ?? res.data?.data?.seccions ?? res.data?.seccions ?? res.data;
      setSeccions(Array.isArray(raw) ? raw : []);
    } catch (err) {
      toast.error("Error cargando secciones");
    }
  };

  useEffect(() => {
    fetchSeccions();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <button onClick={() => navigate(-1)}
        className="flex items-center gap-2 mb-4 text-supernova-600 hover:text-supernova-700">
        <ArrowLeft size={20} /> Volver
      </button>

      <h2 className="text-3xl font-bold mb-6 text-center">Secciones</h2>

      <div className="flex justify-end mb-4">
        <button onClick={() => setModalInfo({ open: true, seccion: null })}
          className="px-4 py-2 bg-supernova-500 text-white rounded-lg hover:bg-supernova-700 flex items-center gap-2">
          <Plus size={18} /> Nueva sección
        </button>
      </div>

      <div className="bg-white shadow rounded-xl overflow-hidden">
        <table className="w-full text-left">
          <thead className="bg-gray-100 text-gray-700">
            <tr>
              <th className="p-3">Nombre</th>
              <th className="p-3 text-center">Acciones</th>
            </tr>
          </thead>
          <tbody>
            {seccions.length === 0 ? (
              <tr>
                <td colSpan="2" className="p-5 text-center text-gray-500">
                  No hay secciones creadas.
                </td>
              </tr>
            ) : (
              seccions.map((secc) => (
                <motion.tr key={secc.id ?? secc._id}
                  initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }}
                  className="border-b">
                  <td className="p-3 font-semibold">{secc.name}</td>
                  <td className="p-3 flex justify-center gap-3">
                    <button onClick={() => setModalInfo({ open: true, seccion: secc })}
                      className="p-2 bg-blue-100 text-blue-700 rounded-lg hover:bg-blue-200">
                      <Pencil size={18} />
                    </button>
                    <button onClick={async () => {
                        if (!window.confirm("¿Eliminar sección?")) return;
                        await API.delete(`/secciones/${secc.id ?? secc._id}`);
                        toast.success("Sección eliminada");
                        fetchSeccions();
                      }}
                      className="p-2 bg-red-100 text-red-700 rounded-lg hover:bg-red-200">
                      <Trash size={18} />
                    </button>
                  </td>
                </motion.tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {modalInfo.open && (
        <SeccionsModal
          seccion={modalInfo.seccion}
          onClose={() => setModalInfo({ open: false, seccion: null })}
          onSaved={fetchSeccions}
        />
      )}
    </div>
  );
}